import type { IOrderAttributeInput, OrderAttribute, OrderAttributeValues } from "@jti/magento";
import type { TradeInOrderAttributes } from "@jti/store/types";

export const prepareConsentOrderAttributes = (
  inputObject: OrderAttributeValues | undefined
): IOrderAttributeInput[] => {
  if (!inputObject) {
    return [];
  }
  return Object.entries(inputObject).map(([key, value]) => ({
    attribute_code: key,
    value,
  }));
};

export const prepareOrderAttributes = (input: OrderAttribute[]): IOrderAttributeInput[] => {
  return input
    .filter((item) => item.value !== undefined)
    .map(({ code, value }) => ({
      attribute_code: code,
      value: value.toString(),
    }));
};

export const prepareTradeInAttributes = (input?: TradeInOrderAttributes | null): IOrderAttributeInput[] => {
  if (!input) {
    return [];
  }

  return Object.entries(input)
    .map(([key, value]) => ({
      attribute_code: key,
      value: value.toString(),
    }))
    .filter((item) => !!item.value);
};
